import { InjectionToken } from '@angular/core';

export type DatetimeFormats = {
  parse: {
    dateInput: any;
  };
  display: {
    dateInput: any;
    monthLabel?: any;
    monthYearLabel: any;
    dateA11yLabel: any;
    monthYearA11yLabel: any;
  };
};

export const DATETIME_FORMATS = new InjectionToken<DatetimeFormats>('datetime-formats');
